import React, { Component } from 'react';

import { Button } from '../components'
import MediaQuery from 'react-responsive';
import matchMedia from 'matchmediaquery'
import logo from "../../images/hero_logo.png"
import showcase from "../../images/showcase.png"
import showcaseIphone from "../../images/showcase_phone.png"
import appStore from "../../images/appstore.svg"
import googlePlay from "../../images/google-play.png"
import Navbar from '../navbar'
import ENV from '../../run-config';

class Landingpage extends Component {
  renderOnboardingButtons(){
    if(this.props.loggedIn){
      return null;
    }
    return (
      <div>
        <Button onClick={this.props.navigateToSignup} label="Registrieren" color="primary" />
        <Button onClick={this.props.navigateToLogin} style={{marginLeft: 10}} label="Einloggen" color="primary" />
      </div>
    )
  }

  render(){
    return (
      <div>
        <Navbar />
        <div className="jumbotronBackground"></div>
        <div className="jumbotron jumbotronFixed text-center">
          <span className="verticalAlign" />
          <img src={logo} className="hero-logo"/>
        </div>

        <div className="jumbotron">
          <div className="container">
            <div className="col-md-6 col-sm-12  col-md-push-6 text-center">
              <img src={showcase} style={{maxHeight: 350, width: 'auto'}} className="verticalAlign"/>
            </div>
            <div className="col-md-6 col-sm-12 col-md-pull-6">
              <h1>Einrichtungs Berater App</h1>
              <p>
                Der Einrichtungsfachhandel ist ein sehr spannendes und viele Bereiche umfassendes Berufsfeld. Einrichtungsfachhändlerinnen und Einrichtungsfachhändler entwerfen Produkte speziell für ihre Kunden. Sei es ein einzelnes Möbelstück, ein Raum oder eine gesamte Wohnung, Einrichtungsberater entwickeln maßgeschneiderte Lösungen für jeden einzelnen Kunden.
              </p>
              <p>
                Um die optimale Wohnlösung zu finden, greift die Einrichtungsberaterin auf ein fundiertes und umfangreiches Wissen in ihrem Fachbereich zurück. Bei der Planung von Wohnräumen muss der Einrichtungsberater die Farben- und Formenlehre perfekt beherrschen, die optimale Raumlösung und Materialien finden und speziell auf die Wünsche des Kunden eingehen.
              </p>
              {this.renderOnboardingButtons()}
            </div>
          </div>
        </div>
        <div className="jumbotron jumbotronBlue text-right">
          <div className="container">
            <div className="col-md-6 col-sm-12 text-center">
              <img src={showcaseIphone} style={{maxHeight: 350, width: 'auto'}} className="verticalAlign"/>
            </div>
            <div className="col-md-6 col-sm-12" style={{marginTop: 50}}>
             <p>
              Um alle diese Kriterien zu erfüllen, wurde ein umfassendes Lerntool für den Einrichtungsfachhandel entwickelt. In Kursen können die verschiedenen Fachgebiete erarbeitet und vertieft werden. Am Ende jedes Kapitels steht ein Test zur Verfügung, um das Gelernte zu festigen und den Lernfortschritt zu überprüfen.
              </p>
              <p>
                  Die Lerninhalte bieten eine solide Grundlage für jeden (angehenden) Einrichtungsberater. Um ein optimales Lernergebnis zu erzielen, steht sowohl eine Web-Version als auch eine App zur Verfügung.
              </p>
              <div style={{marginTop: 40}}>
                <a href={ENV.appStoreUrl}>
                  <img src={appStore} width={150} style={{marginRight: 10}}/>
                </a>
                <a href={ENV.playStoreUrl}>
                  <img src={googlePlay} width={150}/>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Landingpage;


// WEBPACK FOOTER //
// ./src/app/landingpage/landingpage.js